import { NumbersRounded } from '@mui/icons-material';
import Cookies from 'js-cookie'
import jwt from 'jwt-decode'
import { Buffer } from 'buffer';
import axios from 'axios';

/*
 const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
})*/



export const setEmptySession = () => {           
    /*Cookies.set('token',  "" , {secure: true, sameSite: 'none'});    
    Cookies.remove('useremail'); 
    Cookies.remove('user_nom_reel'); */
};

export const setSession =  (token) => {
           

    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (8 * 60 * 60 * 1000)); // Ajoute 12 heures en millisecondes
  
    Cookies.remove('useremail'); 
    Cookies.remove('user_nom_reel'); 
    Cookies.set('token',  token , {secure: true, sameSite: 'Lax', expires: expirationDate});
    //const user = jwt(token); // decode your token here     
    //console.log("---------------- user -------------------");
    //console.log(user);    
    //console.log("-----------------------------------------");
    //Cookies.set('useremail',  user.user.email.trim()); 
    //console.log(user.user.user_nom_reel.trim());
    //Cookies.set('user_nom_reel',  user.user.user_nom_reel.trim());        
};


export const getCookieToken = async () =>  {
    
    let response = await axios.get(process.env.REACT_APP_API + '/auth/getUserAllValue',
                         {headers: { Authorization: "Bearer "+ Cookies.get('token')}}) //axios.defaults.withCredentials = true
    .then((res) => {      
       //alert(res.data);
        return res.data;
    
    })
    .catch((error) => {
        console.log(error)  
        return "Erreur pas de courriel.";          

    });

        //return "Vous n'êtes pas connecté";


    return response;
}

export const getCookieEmail = async () =>  {
    
    let response = await axios.get(process.env.REACT_APP_API + '/auth/getUserEmail',
                     {headers: { Authorization: "Bearer "+ Cookies.get('token')}})
                    .then((res) => {      
                       // alert("getCookieEmail : " +  res.data);
                        return res.data;
                    
                    })
                    .catch((error) => {
                        console.log(error)  
                        return false;          

                    });



           console.log("response",response);

    if(response === false) 
        return "Erreur pas de courriel.";
    else if(response.includes("@"))
         return response;
    else
         return "Erreur pas de courriel.";

}


export const getSessionValide = async () =>  {

   let response =  await axios.get(process.env.REACT_APP_API + '/auth/getValideUser',
                         {headers: { Authorization: "Bearer "+ Cookies.get('token')}})
    .then((res) => {      
        console.log(res.data);
        return res.data; // true false
    
    })
    .catch((error) => {
        console.log(error)  
        return false;      

    });

    return response;
}


export const getIsAdmin = async () =>  {

    let user = await getCookieToken(); //MyAxios.get(process.env.REACT_APP_API + '/auth/getIsAdmin') //axios.defaults.withCredentials = true    
    if(user["create_club"] >= 1 )
       return true;
    else
       return false;    
  
}





export const getSessionExpirer = async () => {
    if(getSessionValide() === true)
        return false;

    return true;
};
  


export  const getUserRule = async (rule,clubid,secteur)  =>  {
  
    let user = await getCookieToken();       
    //console.log("getUserRule",user);
    
        
        if(Number(user["create_club"]) >= 1  ) {          
            //console.log("Tous les droits éccriture/leture seul béatrice et olivier pour le moment");
            return true ;
        }

       
       //read_reports
       if(rule === "read_reports"){
            if(user["read_reports"] >= 1 ){          
                console.log("Droits au rapport");        
                return true ;   
             }
        }

        //read_club
        if(rule === "read_club"){
            if(user["read_all_club"] >= 1 || 
              (Number(user["read_own_club"]) >= 1 && (user["fk_club_master"].includes(clubid))) ||
              (Number(user["read_own_secteur"]) >= 1 && Number(user["secteur"]) === Number(secteur))  ){          
                console.log("Droits lecture au club " + clubid);        
                return true ;   
             }
        }
        
       //read_member
        if(rule === "read_member"){
            if(Number(user["read_member"]) >= 1 ||  Number(user["read_all_club"]) >= 1 ||
            (Number(user["read_own_club"]) >= 1 && (user["fk_club_master"].includes(clubid))) ||
            (Number(user["read_own_secteur"]) >= 1 && Number(user["secteur"]) === Number(secteur)))
            {          
                console.log("Droits lecture des membres " );        
                return true ;   
            }
        }

       //write_club
        if(rule === "write_club"){
            if(user["write_all_club"] >= 1 ||                                                      // droit d'écrire les membre générale
              (user["write_own_club"] >= 1 && user["fk_club_master"].includes(clubid))){   // droit d'écrire dans son club
                console.log("Droits ecriture au club " + clubid);        
                return true ;   
            }
        }
        
       //write_member
       if(rule === "write_member"){
            if(Number(user["write_member"]) >= 1  ||                                             // droit d'écrire les membre générale
              (user["write_own_club"] >= 1 && user["fk_club_master"].includes(clubid)))  // droit d'écrire dans son club, donc ses membres aussi
            {          
                console.log("Droits ecriture des membres " );        
                return true ;   
            }
        }

       //read_secteur
      /* if(rule == "secteur"){
        if(user["secteur"] == 'all'  || 
          (user["secteur"] == 1 && user["fk_club_master"] == clubid)  ){         
            console.log("Droits ecriture des membres " );        
            return true ;   
        }*/
        console.log("Pas acces à " + rule + " sur le club:" +clubid  ); 
        return false;
    }

    
    export const getConsentement = () => {
        
            let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)_CON\s*\=\s*([^;]*).*$)|^.*$/, "$1");
            if(cookieValue)
            { 
                const consentement = Buffer.from(cookieValue, 'base64').toString() //jwt(cookieValue); // decode your token here             
                return consentement;
            }            
            return false;
        }

    export const setConsentement = (cookieValue) => {

        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (1440 * 60 * 60 * 1000)); // Ajoute 60 jours
        const consentement = Buffer.from(cookieValue).toString('base64');  
        
        Cookies.set('_CON',  consentement , {secure: true, sameSite: 'Lax', expires: expirationDate});   
    
    }
       
   

